import { memo } from 'react'

import CurrencyDescriptionItem from 'containers/Menu/AccountInfo/CurrencyDescriptionItem'
import { useAppSelector } from 'store/hooks'
import { getGoldCurrencySelector } from 'store/modules/currencies/selectors'

const GoldCoinAnimatedComponent = () => {
  const goldBalance = useAppSelector(getGoldCurrencySelector)

  return <CurrencyDescriptionItem currency='GC' amount={goldBalance?.amount} showSign />
}

export const GoldCoinAnimated = memo(GoldCoinAnimatedComponent)
